import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const Navigation = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("features");

  useEffect(() => {
    if (location.pathname !== "/") return;

    const ids = ["features", "about", "portfolio", "testimonials"];

    const onScroll = () => {
      const offset = 120;
      let current = "features";

      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY + offset >= top) current = id;
      }

      setActiveSection(current);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  return (
    <nav id='menu' className='navbar  navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <ul className='navbar-nav navbar-left'>
            <li>
              <Link to="/">`
                <img alt="crewcoinlogo" className="crewcoinSm" src={'../img/crewcoinlogo.png'} />
              </Link>
            </li>
            <li></li>
          </ul>
        </div>

        <div className='collapse navbar-collapse' id='bs-example-navbar-collapse-1'>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#features' className={`page-scroll ${activeSection === "features" && location.pathname === "/" ? "cc-nav-active" : ""}`}>
                Features
              </a>
            </li>
            <li>
              <a href='#about' className={`page-scroll ${activeSection === "about" && location.pathname === "/" ? "cc-nav-active" : ""}`}>
                About
              </a>
            </li>
            <li>
              <a href='#portfolio' className={`page-scroll ${activeSection === "portfolio" && location.pathname === "/" ? "cc-nav-active" : ""}`}>
                App
              </a>
            </li>
            <li>
              <a href='#testimonials' className={`page-scroll ${activeSection === "testimonials" && location.pathname === "/" ? "cc-nav-active" : ""}`}>
                Testimonials
              </a>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
            <li>
              <Link to="/signup">Sign Up</Link>
            </li>
            <li>
              <Link to="/login">Login</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
